///
/// EarthBrowser
///
/// Migration v46 to v47: Add stories slice
/// Created by Matt Giger on 9/23/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v46 to v47
 *
 * Changes:
 * - Seeds the new persisted stories slice (story tours: authored stop
 *   sequences with narrative cards and globe annotations) with an empty
 *   state for existing installs.
 */
export function migrateV46toV47(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	if (s.stories) return state

	return {
		...s,
		stories: {
			stories: {},
			deleted: {},
			lastSyncedAt: null,
		},
	}
}
